/**
 * Product Accordion Feature - View More Functionality
 * Handles expanding/collapsing of hidden content sections
 */

class ProductAccordionViewMore {
  constructor() {
    this.init();
  }

  init() {
    // Find all view more buttons
    const viewMoreButtons = document.querySelectorAll('.product-accordion-feature__view-more-btn');
    
    viewMoreButtons.forEach(button => {
      button.addEventListener('click', this.handleViewMoreClick.bind(this));
    });
  }

  handleViewMoreClick(event) {
    const button = event.target;
    const container = button.closest('.product-accordion-feature__container');
    
    if (!container) return;
    
    // Toggle the expanded state
    const isExpanded = container.classList.contains('product-accordion-feature__expanded');
    
    if (isExpanded) {
      // Collapse
      container.classList.remove('product-accordion-feature__expanded');
      button.textContent = 'View more';
    } else {
      // Expand
      container.classList.add('product-accordion-feature__expanded');
      button.textContent = 'View less';
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductAccordionViewMore();
});